// Include jQuery
import axios from 'axios';

const $ = require('jquery');

// jQuery definitions
window.jQuery = $;
window.$ = $;

import autocomplete from 'autocompleter';
import Cropper from 'cropperjs';

/**
 * Kopiert die Werte von Eingabefeldern und Keywords von einem Bereich in einen anderen.
 *
 * Diese Funktion durchsucht alle Eingabefelder mit der Klasse `.copy-field` im Quellbereich
 * und kopiert deren Werte in die entsprechenden Felder im Zielbereich. Zusätzlich werden
 * Keywords (repräsentiert durch `.chips`) ebenfalls kopiert.
 *
 * @param {string|HTMLElement} areaFrom - Der Quellbereich, aus dem die Werte kopiert werden.
 * @param {string|HTMLElement} areaTo - Der Zielbereich, in den die Werte kopiert werden.
 */
window.copyFotothekFields = function(areaFrom, areaTo) {
    var selector = '.copy-field';
    $(areaFrom).find(selector).each(function(i) {
        var source = $(this);
        var target = $(areaTo).find(selector).eq(i);

        if (source.is('select') && target.is('select')) {
            // Kopiert die gesamten Optionen
            target.html(source.html());
        }

        target.val(source.val());
    });

    // Spezielle Felder, die nicht in der Schleife sind
    var firstInput = $(areaTo).find(selector).first();
    var variableName = firstInput.attr('name').match(/\[([^\]]+)]/)[1];

    // Keywords mitkopieren, vorherige Dateistruktur:
    var keywordsFrom = $(areaFrom).find('.chips');
    var keywordsTo = $(areaTo).find('.chips');
    if (keywordsFrom.length && keywordsTo.length) {
        keywordsTo.empty(); // Leeren des Zielbereichs

        keywordsFrom.find('.chip').each(function() {
            var chip = $(this);
            var label = chip.find('span').text();
            var value = chip.find('input[type=hidden]').val();

            // Neues Chip-Element erstellen
            var newChip = $('<span class="chip"><span>' + label + '</span><i class="material-icons" onclick="removeChip(this);">cancel</i><input type="hidden" name="u[' + variableName + '][keywords_id][]" value="' + value + '"></span>');
            keywordsTo.append(newChip);
        });
    }
};

/**
 * Autocomplete
 * @param elementID
 * @param elementWithID
 * @param multikeyArea
 */
window.autoCompleteFotothek = function(elementID, elementWithID, multikeyArea) {
    if (typeof multikeyArea === 'object') {
        $(multikeyArea).find('i').on('click', function() {
            $(this).closest('span').remove();
        });
    }

    const input = document.getElementById(elementID);
    input.setAttribute('autocomplete', 'off');

    // Autocomplete
    autocomplete({
        emptyMsg: LANG_STRINGS.noResults, // eslint-disable-line
        minLength: 0,
        input: input,
        preventSubmit: true,
        showOnFocus: true,
        fetch: function(text, update) {
            text.toLowerCase();

            // Ajax-Call
            $.ajax({
                url: MP_PATH + 'sbr/fotothek/ajax/autocomplete/ajax.autocomplete', // eslint-disable-line
                type: 'post',
                data: $(input),
                dataType: 'json',
                success: function(suggestions) {
                    update(suggestions);
                },
            });

        },
        onSelect: function(item) {
            if (typeof multikeyArea == 'object') {
                if (item.uid !== 0) {
                    // Mehrfachzuordnung möglich
                    $(multikeyArea).append('<span>' + item.label + '<input type="hidden" name="' + $(multikeyArea).data('fieldname') + '" value="' + item.uid + '"><i></i></span>');
                    $(multikeyArea).find('i:last').on('click', function() {
                        $(this).closest('span').remove();
                    });
                    $(input).val('').focus();
                } else {
                    $(this).val('');
                }
            } else {
                // Einfachzuordnung
                if (item.uid !== 0) {
                    $(input).next('input[type=hidden]').val(item.value);
                    input.value = item.label;

                    $(this).val(item.label).attr('title', item.label);
                    $(input).val(item.uid);
                } else {
                    $(this).val('');
                    $(input).val('');
                }
            }
        },
    });

    $(input).on('change', function() {
        // Korrektur eigener benannter Autor statt ID-Zuordnung, wenn eingetippter Wert gespeichert werden soll

        // Korrektur Firefox, nochmal speziell vergleichen
        if ($(this).val() !== $(this).attr('title')) {
            $(input).val('');
        }
    });
};

/**
 * Fotothek Uploader
 */
window.fotothek_fileUploader = function() {
    var fileInput = document.getElementById('fileupload');

    document.getElementById('progress').style.display = 'none';

    fileInput.addEventListener('change', function(event) {
        var files = event.target.files;
        var totalFiles = 0;
        var uploadedFiles = 0;

        if (files.length > 0) {
            totalFiles = files.length;

            fileInput.setAttribute('disabled', 'disabled');
            document.getElementById('save-upload-form').setAttribute('disabled', 'disabled');

            document.getElementById('progress').style.display = 'block';
            document.querySelector('#progress .progress-bar').style.width = '0%';
            document.querySelector('#progress div.progress-text').innerHTML = 'Bitte warten...';

            for (let i = 0; i < files.length; i++) {
                const formData = new FormData();
                formData.append('file', files[i]); // Hier nur das erste ausgewählte File, entsprechend anpassen falls mehrere hochgeladen werden sollen

                axios.post(MP_PATH + 'sbr/fotothek/ajax/helper/ajax.uploadFiles', formData).then(function(response) {
                    uploadedFiles++;

                    var progress = parseInt((uploadedFiles / totalFiles) * 100, 10);

                    document.querySelector('#progress .progress-bar').style.width = progress + '%';
                    document.querySelector('#progress div.progress-text').innerHTML = uploadedFiles + ' von ' + totalFiles + ' Dateien hochgeladen (' + progress + '%)';

                    // Ergebnis des Uploads anzeigen
                    window.executeInnerHTML(document.querySelector('#files'), response.data, true);

                    if (uploadedFiles === totalFiles) {
                        document.querySelector('#progress div.progress-text').innerHTML = '<strong>Fertig!</strong>';
                        document.getElementById('save-upload-form').removeAttribute('disabled');
                        fileInput.removeAttribute('disabled');
                    }
                }).catch(function(error) {
                    // Fehlerbehandlung
                    console.error('Fehler beim Hochladen der Datei:', error);
                });
            }
        }
    });
};

/**
 * fotothek Count Copy
 * @param elementID
 */
window.fotothekCountCopy = function(elementID) {
    // eslint-disable-next-line
    fetch(MP_PATH + 'sbr/fotothek/ajax/helper/countCopy?LANG=' + LANG, {
        method: 'POST',
        body: window.object2FormData({elementID: elementID}),
    }).then((response) => response.json()).then((data) => {
        $('#copy-count').html(data.count);
    });
};

/**
 * Check subcategory
 * @param elementValue
 * @param subCategoryID
 */
window.fotothek_checkSubCategories = function(elementValue, subCategoryID) {
    const subCategoryElement = document.getElementById(subCategoryID);

    const currentSubCategoryID = subCategoryElement.value;
    subCategoryElement.innerHTML = '';

    axios.get(MP_PATH + 'sbr/fotothek/ajax/helper/getSubCategory', {
        params: {
            elementID: elementValue,
            currentSubCategoryID: currentSubCategoryID,
        },
    }).then(response => {
        response.data.forEach(function(response) {
            var option = document.createElement('option');
            option.value = response.value;
            option.text = response.label;
            if (response.selected) {
                option.selected = true;
            }
            subCategoryElement.appendChild(option);
        });
    }).catch(error => {
        if (axios.isCancel(error)) {
            console.log('Request abort:', error.message);
        } else {
            console.error('Error: ', error.message);
        }
    });
};

window.initFotothekCropper = function(container) {
    const containerElement = document.querySelector(container);
    if (containerElement) {
        const cropInput = containerElement.querySelector('[name*="crop"]');
        const dataStartcrop = JSON.parse(containerElement.dataset.startcrop);
        const cropImage = containerElement.querySelector('.js--fotothek-cropper-image');

        if (cropInput && cropImage) {
            // parse all values to int
            for (var key in dataStartcrop) {
                if (Object.prototype.hasOwnProperty.call(dataStartcrop, key)) {
                    dataStartcrop[key] = parseInt(dataStartcrop[key]);
                }
            }

            if (containerElement.querySelector('.cropper-container')) {
                containerElement.querySelector('.cropper-container').remove();
            }

            const cropperOptions = {
                aspectRatio: 2.5,
                movable: false,
                rotatable: false,
                scalable: false,
                zoomable: false,
                zoomOnTouch: false,
                zoomOnWheel: false,
                data: dataStartcrop,
                crop: function(e) {
                    let data = e.detail;
                    const getData = cropper.getData();
                    cropInput.value = JSON.stringify(getData);
                    containerElement.dataset.startcrop = JSON.stringify(getData);
                },
            };

            const cropper = new Cropper(cropImage, cropperOptions);
        }
    }
};
